document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("form .csrf-token").forEach((token) => {
        const form = token.closest("form");
        let submitting = false;

        form.addEventListener("submit", async function (e) {
            if (submitting) return; // let the second submission go through natively
            e.preventDefault();

            const submitter = e.submitter; // the exact button that was clicked

            token.value = await getCSRF();

            submitting = true;
            form.requestSubmit(submitter); // re-fires submit event with the button attached
            submitting = false;
        });
    });
});

async function getCSRF() {
    const res = await fetch("/csrf-token");
    const data = await res.json();
    return data.token;
}

window.getCSRF = getCSRF;
